import React, { useMemo } from 'react';
import { Button, Modal } from 'antd';
import classnames from 'classnames';
import ErrorIcon from '@web-common/components/UI/Icons/svgs/ErrorSvg';
import style from './index.module.scss';
import { getIn18Text } from 'api';
const SendErrorContect = ({ visible, setVisible, receiver, errorMsg, confirm, hideReSend }) => {
    var _a;
    const hideDeleteButton = String(errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.code) === 'FA_MTA_RCPT_ERROR';
    const content = receiver.length > 1 ? (React.createElement("div", { className: classnames(style.errorContect) }, ((_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.msgItem) === null || _a === void 0 ? void 0 : _a.map(item => (React.createElement("div", { className: classnames(style.errorItem) },
        React.createElement("div", { className: classnames(style.email) }, item.email),
        React.createElement("div", { className: classnames(style.desc) },
            getIn18Text('CUOWUYUANYIN\uFF1A'),
            item.reason))))) || '')) : (React.createElement("div", { className: classnames(style.errorContect) },
        getIn18Text('CUOWUYUANYIN\uFF1A'),
        (errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.msgItem) ? errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.msgItem[0].reason : getIn18Text('(WEIZHIYUANYIN')));
    const errorTitle = useMemo(() => {
        var _a, _b;
        const { code, msgItem } = errorMsg;
        if (code === 'FA_MTA_RCPT_ERROR' && (msgItem === null || msgItem === void 0 ? void 0 : msgItem.length) === 1 && msgItem[0].code === 'MTA5102') {
            return getIn18Text('YOUJIANFASONGSHI') + getIn18Text('QINGGENGHUANYUMING');
        }
        return (getIn18Text('YOUJIANFASONGSHI') +
            ((errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.msgItem) && ((_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.msgItem) === null || _a === void 0 ? void 0 : _a.length) > 1 ? `${(_b = errorMsg.msgItem) === null || _b === void 0 ? void 0 : _b.length}位联系人邮箱错误` : getIn18Text('LIANXIRENYOUXIANGCW')));
    }, [errorMsg]);
    return (React.createElement(Modal, { wrapClassName: "modal-dialog", onCancel: () => {
            setVisible(false);
        }, visible: visible, footer: null },
        React.createElement("div", { className: "modal-content", style: { marginTop: '10px' } },
            React.createElement("div", { className: "modal-icon" },
                React.createElement(ErrorIcon, { className: "error-icon" })),
            React.createElement("div", { className: "modal-text" },
                React.createElement("div", { className: "title" }, errorTitle),
                content,
                React.createElement("div", { className: "btns" },
                    React.createElement("div", null),
                    React.createElement("div", null,
                        React.createElement(Button, { className: "cancel", onClick: () => {
                                setVisible(false);
                            } }, getIn18Text('QUXIAO')),
                        !hideReSend && receiver && receiver.length > 1 && !hideDeleteButton ? (React.createElement(Button, { className: "cancel", onClick: () => {
                                confirm(errorMsg);
                                setVisible(false);
                            } }, getIn18Text('SHANCHUCUOWUYOU'))) : ('')))))));
};
export default SendErrorContect;
